import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import ModalDialog from 'ui/components/modal-dialog';

var withEscape = function withEscape(WrappedComponent) {
  var WithEscape = /*#__PURE__*/function (_React$Component) {
    _inherits(WithEscape, _React$Component);

    var _super = _createSuper(WithEscape);

    function WithEscape(props) {
      var _this;

      _classCallCheck(this, WithEscape);

      _this = _super.call(this, props);
      _this.escToClose = _this.escToClose.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(WithEscape, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        window.addEventListener("keydown", this.escToClose);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("keydown", this.escToClose);
      }
    }, {
      key: "escToClose",
      value: function escToClose(event) {
        var _this$props$actions = this.props.actions,
            cancel = _this$props$actions.cancel,
            close = _this$props$actions.close;

        if (event.key === "Escape") {
          cancel ? cancel.handler() : close.handler();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, this.props);
      }
    }]);

    return WithEscape;
  }(React.Component);

  WithEscape.displayName = "WithEscape(".concat(getDisplayName(WrappedComponent), ")");
  return WithEscape;
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default withEscape(ModalDialog);